// store/modules/images.js
const state = {
  // 存储所有图片数据，以 name 为 key
  allImages: {},
  // 存储图片的完整 URL 映射
  imageUrls: {},
  isLoaded: false
}

const mutations = {
  SET_ALL_IMAGES(state, images) {
    // 将数组转换为以 name 为 key 的对象
    const imagesMap = {}
    const urlsMap = {}
    
    images.forEach(item => {
      imagesMap[item.name] = item
      // 构建完整的图片 URL
      urlsMap[item.name] = `${process.env.VUE_APP_BASE_API}${item.path}`
    })
    
    state.allImages = imagesMap
    state.imageUrls = urlsMap
    state.isLoaded = true
  },
  CLEAR_IMAGES(state) {
    state.allImages = {}
    state.imageUrls = {}
    state.isLoaded = false
  }
}

const actions = {
  // 获取所有图片
  async fetchAllImages({ commit, state }) {
    // 如果已经加载过，直接返回
    if (state.isLoaded) {
      return state.allImages
    }
    
    try {
      const images = await getAllImages()
      commit('SET_ALL_IMAGES', images)
      return images
    } catch (error) {
      console.error('获取图片数据失败:', error)
      throw error
    }
  },
  
  // 根据 name 获取图片信息
  async getImageByName({ state, dispatch }, name) {
    // 如果还没加载，先加载数据
    if (!state.isLoaded) {
      await dispatch('fetchAllImages')
    }
    
    return state.allImages[name] || null
  },
  
  // 根据 name 获取图片 URL
  async getImageUrlByName({ state, dispatch }, name) {
    // 如果还没加载，先加载数据
    if (!state.isLoaded) {
      await dispatch('fetchAllImages')
    }
    
    return state.imageUrls[name] || ''
  }
}

const getters = {
  // 获取所有图片
  getAllImages: state => state.allImages,
  // 获取所有图片 URL 映射
  getAllImageUrls: state => state.imageUrls,
  // 根据 name 获取图片
  getImageByName: state => name => state.allImages[name] || null,
  // 根据 name 获取图片 URL
  getImageUrlByName: state => name => state.imageUrls[name] || '',
  // 检查是否已加载
  isImagesLoaded: state => state.isLoaded
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}